import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useSingleDealerQuery from '../api/use-single-dealer-query';
import useSingleVehicleQuery from '../api/use-single-vehicle-query';
import { getLang } from '../translations';
import { DealerData, VehicleData } from '../types';
import { useFeatureServices } from '../use-feature-services';
import { VehicleDetailsContext } from '../utils/details-context';
import { createConfiguration, createConstantData, createPartner } from '../utils/get-tracking-event-data';
import { DetailsPage } from './Page';

export default () => {
  const lang = getLang();
  const [ vehicle, setVehicle ] = useState<VehicleData>();
  const [ dealer, setDealer ] = useState<DealerData>();

  const { tracking } = useFeatureServices();

  const { vin } = useParams();
  const { isLoading, data } = useSingleVehicleQuery(vin as string);
  const dealerQuery = useSingleDealerQuery(vehicle?.dealer_id as string)

  useEffect(() => {
    if (data) {
      setVehicle(data as VehicleData);
    }
  }, [data]);

  useEffect(() => {
    if (dealerQuery && dealerQuery?.isSuccess) {
      const dealerData = dealerQuery?.data as DealerData;
      setDealer(dealerData);
    }
  }, [dealerQuery]);

  useEffect(() => {
    if (vehicle && dealer) {
      tracking.track('VWBasic_Vehicle_Pageload', {
        ...createConstantData('VWBasic_Vehicle_Pageload', vehicle?.category),
        configuration: createConfiguration('VWBasic_Vehicle_Pageload', vehicle as VehicleData, lang),
        partner: createPartner(dealer)
      });
    }
  }, [vehicle, dealer]);

  return (
    isLoading
    ? <></>
    : <VehicleDetailsContext.Provider value={{vehicle, dealer}}>
      <DetailsPage />
    </VehicleDetailsContext.Provider>
  );
};
